"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustTimeRange = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
function adjustTimeRange(timeRange) {
    if (timeRange) {
        if (timeRange.endTime) {
            const endTimeStamp = Number(timeRange.endTime);
            const isToday = (0, dayjs_1.default)().format("YYYY-MM-DD") === (0, dayjs_1.default)(endTimeStamp).format("YYYY-MM-DD");
            if (isToday) {
                return Object.assign(Object.assign({}, timeRange), { endTime: `${(0, dayjs_1.default)().valueOf()}` });
            }
            return Object.assign(Object.assign({}, timeRange), { endTime: `${(0, dayjs_1.default)(endTimeStamp).add(1, "day").valueOf()}` });
        }
    }
    return timeRange;
}
exports.adjustTimeRange = adjustTimeRange;
